import React from 'react';
import PropTypes from 'prop-types';

import styles from './BaseButton.css';

const IPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledClassName: PropTypes.string,
  enabledClassName: PropTypes.string,
  pressedClassName: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
};

const defaultProps = {
  className: '',
  disabled: false,
  disabledClassName: '',
  enabledClassName: '',
  pressedClassName: '',
  onClick: () => {},
  style: null,
};

class BaseButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mouseDown: false,
    };
    this._handleClick = this._handleClick.bind(this);
    this._onMouseDown = this._onMouseDown.bind(this);
    this._onMouseUp = this._onMouseUp.bind(this);
  }

  _handleClick(event) {
    if (!this.props.disabled) {
      this.props.onClick(event);
    }
  }

  _onMouseDown() {
    if (!this.props.disabled) {
      this.setState({
        mouseDown: true,
      });
    }
  }

  _onMouseUp() {
    if (!this.props.disabled) {
      this.setState({
        mouseDown: false,
      });
    }
  }

  render() {
    const mouseDownClass = this.state.mouseDown ? this.props.pressedClassName : '';
    const disabledClass = this.props.disabled ?
      `${this.props.disabledClassName} ${styles.disabled}` : this.props.enabledClassName;
    return (
      <button
        className={[styles.container, mouseDownClass, disabledClass, this.props.className].join(' ')}
        disabled={this.props.disabled}
        onClick={this._handleClick}
        onMouseDown={this._onMouseDown}
        onMouseUp={this._onMouseUp}
        style={this.props.style}
      >
        {this.props.children}
      </button>
    );
  }
}

BaseButton.propTypes = IPropTypes;
BaseButton.defaultProps = defaultProps;

export { BaseButton };



// WEBPACK FOOTER //
// ./src/common/base-button/BaseButton.jsx